import React from "react";
import { useParams } from "react-router-dom";
import { useUpdatePayable } from "../../hooks/useUpdatePayable";
import { usePayable } from "../../hooks/usePayable";
import { EditDateButton } from "../../components/EditDateButton";

type Props = {
  date?: string | null;
};

export function EditPayDateButton({ date }: Props) {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const { refetchPayable } = usePayable(invoiceId);
  const { updatePayable } = useUpdatePayable(invoiceId);

  return (
    <EditDateButton
      date={date}
      title="Select a planned payment date"
      onSave={async (plannedDate) => {
        await updatePayable({ plannedDate });
        await refetchPayable();
      }}
    />
  );
}
